import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { StationReminderAlertSelectRequest } from "./StationReminderAlertSelectRequest";
import { StationReminderAlertInsertRequest } from "./StationReminderAlertInsertRequest";
import { StationReminderAlertPersonInsertRequest } from "./StationReminderAlertPersonInsertRequest";
import { StationReminderAlertPersonRemoveRequest } from "./StationReminderAlertPersonRemoveRequest";
import { StationReminderAlertUpdateRequest } from "./StationReminderAlertUpdateRequest";
import { LoadPersonRequest } from "./LoadPersonRequest";
import { StationReminderAlertPersonToggleRequest } from "./StationReminderAlertPersonToggleRequest";
import { StationReminderAlertCopyRequest } from "./StationReminderAlertCopyRequest";

@Injectable()
export class DataService_ReminderAlertSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	StationReminderAlertInfoSelectList(parms: StationReminderAlertSelectRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertInfoSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertInsert(parms: StationReminderAlertInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertToggle(StationReminderAlertID, Active) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertToggle?StationReminderAlertID=" + StationReminderAlertID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertDelete(StationReminderAlertID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertDelete?StationReminderAlertID=" + StationReminderAlertID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertPersonInfoSelectList(StationReminderAlertID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertPersonInfoSelectList?StationReminderAlertID=" + StationReminderAlertID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertPersonInsert(parms: StationReminderAlertPersonInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertPersonInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertPersonRemove(parms: StationReminderAlertPersonRemoveRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertPersonRemove";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertPersonToggle(parms: StationReminderAlertPersonToggleRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertPersonToggle";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadSoundPopupList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/LoadSoundPopupList?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertUpdate(parms: StationReminderAlertUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AssignPersonSelectList(parms: LoadPersonRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/AssignPersonSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderAlertCopy(parms: StationReminderAlertCopyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/StationReminderAlertCopy";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
